import { render } from "./StatsAdmin.vue?vue&type=template&id=4247c9be"
import script from "./StatsAdmin.vue?vue&type=script&lang=js"
export * from "./StatsAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__